import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const pronunciationAndToneQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.PRONUNCIATION,
        questionText: "¿Cuál es la sílaba tónica en la palabra 'teléfono'?",
        options: ["te", "fo", "lé", "no"],
        correctAnswerIndex: 2
    },
    {
        category: QuizCategory.PRONUNCIATION,
        questionText: "¿Cómo se pronuncia correctamente la pregunta '¿Vienes mañana?' en términos de entonación?",
        options: [
            "Entonación descendente al final",
            "Entonación ascendente al final",
            "Entonación plana sin variación",
            "Entonación ascendente en el medio y descendente al final"
        ],
        correctAnswerIndex: 1
    },
    {
        category: QuizCategory.PRONUNCIATION,
        questionText: "¿Cuál es la pronunciación correcta de la letra 'g' en la palabra 'gigante'?",
        options: [
            "Como una 'g' suave en ambas sílabas",
            "Como una 'g' suave en la primera sílaba y una 'g' fuerte en la segunda",
            "Como una 'g' fuerte en ambas sílabas",
            "Como una 'g' fuerte en la primera sílaba y una 'g' suave en la segunda"
        ],
        correctAnswerIndex: 3
    },
    {
        category: QuizCategory.PRONUNCIATION,
        questionText: "En el habla rápida, ¿qué sonido vocálico suele reducirse en la palabra 'para'?",
        options: [
            "La 'a' inicial",
            "La 'a' final",
            "La 'p' inicial",
            "La 'r' intermedia"
        ],
        correctAnswerIndex: 1
    },
    {
        category: QuizCategory.PRONUNCIATION,
        questionText: "¿Cuál de las siguientes palabras contiene un hiato?",
        options: ["caída", "puerta", "cielo", "cuento"],
        correctAnswerIndex: 0
    },
    {
        category: QuizCategory.PRONUNCIATION,
        questionText: "¿Cuál de las siguientes palabras lleva tilde?",
        options: ["fui", "dio", "café", "vio"],
        correctAnswerIndex: 2
    },
    {
        category: QuizCategory.PRONUNCIATION,
        questionText: "Identifica la palabra con hiato:",
        options: ["caída", "puerta", "cielo", "cuento"],
        correctAnswerIndex: 0
    }
];

export default pronunciationAndToneQuestions;